// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { useGlobalState } from './globalState/GlobalStateProvider';
import ShadeOverlay from './ShadeOverlay';
import { mobileView } from './api/utility';

const Wrapper = styled.div`
    width: 100vw;
    position: absolute;
    height: ${({ height }) => height};
    overflow: hidden;
    display: flex;
    align-items: stretch;
    flex-direction: column;
`;

const Shade = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    background: #00000080;
    display: flex;
    align-items: flex-end;
`;

const Video = styled.video`
    width: 100vw;
    object-fit: cover;
    height: 100vh;
    top: 0;
    left: 0;
`;

const BackDrop = ({ src, ...props }) => {
    const {
        state: {
            // mobileView
        },
    } = useGlobalState();

    if (mobileView) return null;

    return (
        <Wrapper height={props.height || '75vh'}>
            {
                props.video ?
                    <Video autoPlay loop muted height={props.height || '75vh'}>
                        <source src={src} type="video/mp4" />
                    </Video>
                    : null
            }
            <Shade>
                <ShadeOverlay />
            </Shade>
        </Wrapper>
    );
}

export default BackDrop;